//overrule-customs-light
const BASE_FAQ_URL = 'https://www.certifiedpickup.com/en/certified-pick-shipping-agent';
export const OVERRULE_CUSTOMS_LIGHT_FAQ_PAGES = {
  OVERRULE_LIGHT: `${BASE_FAQ_URL}`,
};

const BASE_TRANSPORTER_LEARN_MORE_URL = 'https://documentation.nxtport.com/certified-pickup/';
export const TRANSPORTER_LIMITED_ACCESS_LEARN_MORE = {
  WEB: `${BASE_TRANSPORTER_LEARN_MORE_URL}cinvio-registration`,
  WEB_AND_API: `${BASE_TRANSPORTER_LEARN_MORE_URL}getting-started-with-the-api-integration`,
};
